<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <div class="main-container-mobile">
                <div class="first-container-mobile">
                    <div class="first-block">
                        <div class="logo-container-footer">
                            <img src="../assets/img/bal-zvuk-logo.svg" alt="logo" class="jameson-logo-mobile" />
                        </div>
                        <p class="title-first-block-mobile">
                            <span v-for="(line, i) in config.title" :key="i">
                                {{ line }}
                                <br v-if="i < config.title.length - 1">
                            </span>
                        </p>
                        <!-- <img :src="config.logoMain" alt="logo" class="jameson-logo" /> -->
                        <!-- <img :src="config.logoInvisible" alt="jameson" class="jameson-invisible" /> -->
                        <p class="description-first-block-mobile" >
                            <span v-for="(line, i) in config.description" :key="i" :class="{ 'with-padding': i === 1 || i === 2 }">
                                {{ line }}
                                <br v-if="i < config.description.length - 1">
                            </span>
                        </p>
                        <!-- <button @click="scrollToDetails"
                                class="btn-form-submit-mobile mt-5 mb-5"
                                style="max-width: 300px;"
                                >Подробнее
                        </button> -->
                        <!-- <div class="logo-container-footer mb-5">
                            <img src="../assets/img/first-block-img-mobile.png" alt="logo"
                                class="big-img-first-block-mobile" />
                        </div> -->
                        <p class="description-first-block-small-mobile">
                            <span v-for="(line, i) in config.smallDescrtiption" :key="i">
                                {{ line }}
                                <br v-if="i < config.smallDescrtiption.length - 1">
                            </span>
                        </p>
                    </div>
                    <!-- <div class="second-block">
                                <img :src="config.bigImage" alt="jameson" class="big-img-first-block" />
                            </div> -->
                </div>
                <div id="second-section" class="second-contaier second-contaier-mobile"
                    :style="{ '--bg-url': `url(${require('@/assets' + config.bgImageSecondMobile)})` }">
                    <div class="second-first-container-mobile">
                        <div class="second-first-block-mobile">
                            <p class="second-block-title-mobile">{{ config.titleCond }}</p>
                            <!-- <p class="second-block-description-mobile">
                                <span>{{ config.secondTitleCond }}</span>
                            </p> -->
                        </div>
                        <div class="second-second-block-mobile">
                            <div v-for="(cond, index) in config.conditions" :key="index"
                                class="d-flex flex-row align-items-center condition-container">
                                <p class="number-mobile">{{ index + 1 }}.</p>
                                <p class="condition-text-mobile"><span v-html="cond"></span></p>
                            </div>
                            <!-- <div class="d-flex flex-row align-items-center condition-container">
                                <p class="number">1.</p>
                                <p class="condition-text"><span>Подпишись</span>
                                    <span>на наш аккаунт</span>
                                </p>

                            </div>
                            <div class="d-flex flex-row align-items-center condition-container">
                                <p class="number">2.</p>
                                <p class="condition-text">
                                    <span>Сделай репост этой публикации себе в сторис или ленту</span>
                                    <span> с отметкой нашего аккаунта.</span>
                                </p>


                            </div>
                            <div class="d-flex flex-row align-items-center condition-container">
                                <p class="number">3.</p>
                                <p class="condition-text">
                                    <span>В комментариях под постом отметь двух друзей, с</span>
                                    <span>кем пошёл(а) бы на вечеринку.</span>
                                </p>

                            </div>
                            <div class="d-flex flex-row align-items-center condition-container">
                                <p class="number">4.</p>
                                <p class="condition-text"><span>Заполни короткую форму по ссылке в профиле.</span></p>
                            </div> -->
                        </div>

                    </div>
                </div>

                <div class="third-container-mobile" id="registration-section">
                    <!-- <img src="@/assets/img/jameson-form-bg-mobile-left.png" alt="Background" class="background-image-mobile-topleft" />
                <img src="@/assets/img/jameson-form-bg-mobile-right.png" alt="Background" class="background-image-mobile-topright" /> -->
                    <div class="registration-body-container-mobile">
                        <div class="title-container">
                            <p class="text-title-mobile">Заполните анкету</p>
                        </div>
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#171F43" />
                        </div>
                        <div v-else-if="formError" class="form-error">
                            <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                            <button class="btn-form-submit mt-10 mb-10" @click="getFormFields">Повторить
                                попытку</button>
                        </div>
                        <div v-else class="form-main-mobile">
                            <div v-for="question in normalQuestions" :key="question.id" class="form-container">
                                <!-- input text/email/etc -->
                                <div>
                                    <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body-mobile"
                                        v-model="formData[question.id]" :placeholder="getPlaceholder(question, true)"
                                        @blur="markTouched(question)" @input="validateField(question)" />
                                    <input v-else-if="question.type === 4" class="input-body-mobile"
                                        v-model="formData[question.id]" v-mask="'+7(###) ###-##-##'"
                                        placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                        @focus="onPhoneFocus(question)" @input="onPhoneInput(question)" />
                                    <!-- select -->
                                    <v-select v-else-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                        :items="question.answers" item-text="name" item-value="id" dense outlined
                                        hide-details :placeholder="getPlaceholder(question, true)" class="mb-3 pt-1">
                                        <template v-slot:selection="{ item }">
                                            <div v-if="item" style="white-space: normal; word-break: break-word;">
                                                {{ item.name }}
                                            </div>
                                            <span v-else class="truncate-text">
                                                {{ getPlaceholder(question, true) }}
                                            </span>
                                        </template>
                                    </v-select>
                                    <div class="error-message">
                                        <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="btn-container mt-6">
                                <div v-for="question in filteredQuestions" :key="question.id"
                                    class="checkbox-container">

                                    <div class="checkbox-content">
                                        <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                            :id="question.id" @change="markTouched(question)"
                                            @input="validateField(question)" />

                                        <label class="checkbox-label" :for="question.id" style="color: black;">
                                            <!-- если это согласие на обработку персональных данных -->
                                            <template v-if="question.number === 7">
                                                Я даю согласие на
                                                <a style="color: black; text-decoration: underline;"
                                                    @click.stop.prevent="openPopup('offer')">
                                                    сбор и обработку персональных данных
                                                </a>
                                            </template>

                                            <!-- для всех остальных чекбоксов -->
                                            <template v-else>
                                                {{ question.name }}
                                            </template>
                                        </label>
                                    </div>

                                </div>
                                <button @click="confirmRegistration"
                                    class="btn-form-submit-mobile mt-10 mb-10"
                                    :disabled="isSendSms"
                                    >{{ isSendSms ? "Отправка..." : "Зарегистрироваться" }}</button>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="main-container-footer-mobile">


                    <div class="footer-container-mobile">
                        <div class="politics-container-mobile">
                            <div class="logo-container-footer">
                                <img src="../assets/img/ballantines-footer-logo.svg" alt="" class="jameson-logo-footer-mobile" />
                            </div>
                            <div class="d-flex flex-column">
                                <div class="footer-first-block">
                                    <p class="link-text-mobile pb-5">{{ config.footer.warningText }}</p>
                                    <a class="link-text-mobile" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <!-- <div class="logo-container-footer-2">
                                    <img src="../assets/img/j-invicible.png" alt="logo" class="j-logo-footer" />
                                </div> -->
                                <div class="footer-second-block">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text">
                                        <a class="footer-main-text" @click="openPopup(item.href)">{{ item.text }}</a>
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div class="social-container-mobile">
                            <div class="footer-j-logo">
                                <!-- <img :src="config.footer.logo" class="j-logo-footer" alt="j-logo"> -->
                            </div>
                            <div class="social-icons-container">
                                <div @click="goTo('https://www.instagram.com/ballantines_kz/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="#0000AA"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.3973 21.1698C36.3467 20.0215 36.161 19.232 35.895 18.548C35.6206 17.8218 35.1984 17.1717 34.6452 16.6313C34.1048 16.0825 33.4504 15.656 32.7327 15.3859C32.0447 15.1199 31.2593 14.9342 30.111 14.8835C28.9541 14.8286 28.5869 14.8159 25.6527 14.8159C22.7185 14.8159 22.3512 14.8286 21.1986 14.8792C20.0503 14.9299 19.2609 15.1157 18.5769 15.3816C17.8507 15.656 17.2006 16.0782 16.6601 16.6313C16.1113 17.1717 15.685 17.8261 15.4147 18.5439C15.1487 19.232 14.963 20.0172 14.9123 21.1655C14.8574 22.3224 14.8447 22.6897 14.8447 25.6239C14.8447 28.5581 14.8574 28.9253 14.9081 30.0779C14.9587 31.2263 15.1445 32.0157 15.4106 32.6998C15.685 33.4259 16.1113 34.076 16.6601 34.6164C17.2006 35.1653 17.8549 35.5918 18.5727 35.8619C19.2609 36.1279 20.046 36.3136 21.1945 36.3642C22.3469 36.415 22.7144 36.4276 25.6486 36.4276C28.5828 36.4276 28.95 36.415 30.1026 36.3642C31.2509 36.3136 32.0404 36.1279 32.7243 35.8619C34.1767 35.3003 35.325 34.152 35.8866 32.6998C36.1524 32.0116 36.3383 31.2263 36.3889 30.0779C36.4395 28.9253 36.4522 28.5581 36.4522 25.6239C36.4522 22.6897 36.4479 22.3224 36.3973 21.1698ZM34.4511 29.9935C34.4046 31.049 34.2273 31.6189 34.0796 31.9989C33.7164 32.9404 32.9692 33.6876 32.0277 34.0508C31.6477 34.1985 31.0736 34.3758 30.0223 34.4222C28.8824 34.473 28.5405 34.4855 25.657 34.4855C22.7734 34.4855 22.4272 34.473 21.2915 34.4222C20.236 34.3758 19.6661 34.1985 19.2861 34.0508C18.8176 33.8776 18.3911 33.6032 18.0449 33.2443C17.6861 32.8939 17.4116 32.4717 17.2385 32.0032C17.0907 31.6232 16.9134 31.049 16.8671 29.9978C16.8163 28.8579 16.8038 28.5159 16.8038 25.6323C16.8038 22.7487 16.8163 22.4026 16.8671 21.267C16.9134 20.2115 17.0907 19.6415 17.2385 19.2616C17.4116 18.7929 17.6861 18.3666 18.0492 18.0202C18.3995 17.6614 18.8217 17.387 19.2904 17.214C19.6703 17.0662 20.2446 16.8889 21.2958 16.8424C22.4357 16.7918 22.7777 16.7791 25.6611 16.7791C28.5489 16.7791 28.8908 16.7918 30.0266 16.8424C31.0821 16.8889 31.652 17.0662 32.032 17.214C32.5005 17.387 32.927 17.6614 33.2731 18.0202C33.632 18.3707 33.9064 18.7929 34.0796 19.2616C34.2273 19.6415 34.4046 20.2156 34.4511 21.267C34.5018 22.4069 34.5145 22.7487 34.5145 25.6323C34.5145 28.5159 34.5018 28.8536 34.4511 29.9935Z"
                                            fill="#0000AA" />
                                        <path
                                            d="M25.6543 20.0715C22.5893 20.0715 20.1025 22.5581 20.1025 25.6233C20.1025 28.6884 22.5893 31.175 25.6543 31.175C28.7194 31.175 31.206 28.6884 31.206 25.6233C31.206 22.5581 28.7194 20.0715 25.6543 20.0715ZM25.6543 29.2246C23.6659 29.2246 22.053 27.6118 22.053 25.6233C22.053 23.6347 23.6659 22.022 25.6543 22.022C27.6428 22.022 29.2556 23.6347 29.2556 25.6233C29.2556 27.6118 27.6428 29.2246 25.6543 29.2246Z"
                                            fill="#0000AA" />
                                        <path
                                            d="M32.7222 19.8522C32.7222 20.568 32.1419 21.1483 31.426 21.1483C30.7102 21.1483 30.1299 20.568 30.1299 19.8522C30.1299 19.1363 30.7102 18.5562 31.426 18.5562C32.1419 18.5562 32.7222 19.1363 32.7222 19.8522Z"
                                            fill="#0000AA" />
                                    </svg>
                                </div>
                                <!-- <div @click="goTo('https://www.youtube.com/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.7156 24.4729C36.7156 23.9881 36.6348 23.4225 36.6348 22.776C36.554 22.1295 36.4732 21.4831 36.3924 20.9174C36.2308 20.2709 35.9884 19.7861 35.5035 19.3821C35.0995 18.978 34.5338 18.7356 33.9682 18.6548C32.1096 18.4123 29.3621 18.3315 25.6449 18.3315C21.9278 18.3315 19.0995 18.4123 17.3217 18.6548C16.756 18.7356 16.1904 18.978 15.7863 19.3821C15.3823 19.7861 15.0591 20.2709 14.8974 20.9174C14.7358 21.4831 14.655 22.0487 14.655 22.776C14.5742 23.4225 14.5742 23.9881 14.5742 24.4729C14.5742 24.9578 14.5742 25.5235 14.5742 26.3315C14.5742 27.1396 14.5742 27.7861 14.5742 28.1901C14.5742 28.675 14.655 29.2406 14.655 29.8871C14.7358 30.5336 14.8166 31.18 14.8974 31.7457C15.0591 32.3921 15.3015 32.877 15.7863 33.281C16.1904 33.6851 16.756 33.9275 17.3217 34.0083C19.1803 34.2507 21.9278 34.3315 25.6449 34.3315C29.3621 34.3315 32.1904 34.2507 33.9682 34.0083C34.5338 33.9275 35.0995 33.6851 35.5035 33.281C35.9075 32.877 36.2308 32.3921 36.3924 31.7457C36.554 31.18 36.6348 30.6144 36.6348 29.8871C36.7156 29.2406 36.7156 28.675 36.7156 28.1901C36.7156 27.7053 36.7156 27.1396 36.7156 26.3315C36.7156 25.5235 36.7156 24.877 36.7156 24.4729ZM29.9278 26.978L23.5439 30.9376C23.4631 31.0184 23.3015 31.0992 23.1399 31.0992C22.9783 31.0992 22.8975 31.0992 22.7358 31.0184C22.4934 30.8568 22.3318 30.6144 22.3318 30.2911V22.2911C22.3318 21.9679 22.4934 21.7255 22.7358 21.5639C22.9783 21.4023 23.3015 21.4023 23.5439 21.5639L29.9278 25.5235C30.1702 25.6851 30.3318 25.9275 30.3318 26.1699C30.3318 26.4123 30.1702 26.8164 29.9278 26.978Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                            </div>


                        </div>
                    </div>

                </div>
            </div>
            <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms" @verifyCode="submitAnswersWithCode"
                @closePopup="showOtpPopup = false" :success="otpSuccess" :errorMessage="otpError"
                :loading="otpVerifying" />
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <div class="main-container">
                <div class="first-container">
                    <div class="first-block">
                        <img src="../assets/img/bal-zvuk-logo.svg" alt="logo" class="jameson-logo" />
                        <p class="title-first-block">
                            <span v-for="(line, i) in config.title" :key="i">
                                {{ line }}
                                <br v-if="i < config.title.length - 1">
                            </span>
                        </p>
                        <!-- <img src="../assets/img/jameson-logo-age-confirm.png" alt="logo" class="jameson-logo" /> -->
                        <!-- <img :src="config.logoMain" alt="logo" class="jameson-logo" /> -->
                        <!-- <img :src="config.logoInvisible" alt="jameson" class="jameson-invisible" /> -->
                        <!-- <img src="../assets/img/j-invicible.png" alt="logo" class="jameson-invisible" /> -->
                        <p class="description-first-block">
                            <span v-for="(line, i) in config.description" :key="i" :class="{ 'with-padding': i === 1 || i === 2 }">
                                {{ line }}
                                <br v-if="i < config.description.length - 1">
                            </span>
                        </p>
                        <!-- <button @click="scrollToDetails"
                                class="btn-form-submit mt-10 mb-10"
                                style="width: 250px;"
                                >Подробнее
                        </button> -->
                        <p class="description-first-block-small">
                            <span v-for="(line, i) in config.smallDescrtiption" :key="i">
                                {{ line }}
                                <br v-if="i < config.smallDescrtiption.length - 1">
                            </span>
                        </p>
                    </div>
                    <!-- <div class="second-block">
                        <img src="../assets/img/test.jpg" alt="logo" class="big-img-first-block" />       
                    </div> -->
                </div>
                <div class="second-contaier" id="second-section"
                    :style="{ '--bg-url': `url(${require('@/assets' + config.bgImageSecond)})` }">
                    <div class="second-first-container">
                        <div class="second-first-block">
                            <p class="second-block-title">{{ config.titleCond }}</p>
                            <!-- <p class="second-block-description">
                                <span>{{ config.secondTitleCond }}</span>
                            </p> -->
                        </div>
                        <div class="second-second-block">
                            <div v-for="(cond, index) in config.conditions" :key="index"
                                class="d-flex flex-row align-items-center condition-container">
                                <p class="number">{{ index + 1 }}.</p>
                                <p class="condition-text"><span v-html="cond"></span></p>
                            </div>

                        </div>

                    </div>
                </div>

                <div class="third-container" id="registration-section">
                    <!-- <img src="@/assets/img/jameson-form-bg-left.png" alt="Background" class="background-image-mobile-topleft" />
                    <img src="@/assets/img/jameson-form-bg-right.png" alt="Background" class="background-image-mobile-topright" /> -->
                    <div class="registration-body-container">
                        <div class="title-container">
                            <p class="text-title">Заполните анкету</p>
                            <!-- <p style="color: white">Возраст: {{ getUserAge || 'Нет данных' }}</p> -->
                        </div>
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#171F43" />
                        </div>
                        <div v-else-if="formError" class="form-error">
                            <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                            <button class="btn-form-submit mt-10 mb-10" @click="getFormFields">Повторить
                                попытку</button>
                        </div>
                        <div v-else class="form-main">
                            <div v-for="question in normalQuestions" :key="question.id" class="form-container">
                                <!-- input text/email/etc -->
                                <div>
                                    <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body"
                                        v-model="formData[question.id]" :placeholder="getPlaceholder(question)"
                                        @blur="markTouched(question)" @input="validateField(question)" />
                                    <input v-else-if="question.type === 4" class="input-body"
                                        v-model="formData[question.id]" v-mask="'+7(###) ###-##-##'"
                                        placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                        @focus="onPhoneFocus(question)" @input="onPhoneInput(question)" />
                                    <!-- select -->
                                    <v-select v-else-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                        :items="question.answers" item-text="name" item-value="id" dense outlined
                                        hide-details :placeholder="getPlaceholder(question)" class="my-select mb-4">
                                        <template v-slot:selection="{ item }">
                                            <div class="select-input" style="white-space: normal; word-break: break-word;">
                                                {{ item.name }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="error-message">
                                        <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!formError" class="btn-container mt-6 mb-5">
                            <div v-for="question in filteredQuestions" :key="question.id" class="checkbox-container">

                                <div class="checkbox-content">
                                    <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                        :id="question.id" @change="markTouched(question)"
                                        @input="validateField(question)" />

                                    <label class="checkbox-label" :for="question.id" style="color: black;">
                                        <!-- если это согласие на обработку персональных данных -->
                                        <template v-if="question.number === 7">
                                            Я даю согласие на
                                            <a style="color: black; text-decoration: underline;"
                                                @click.stop.prevent="openPopup('offer')">
                                                сбор и обработку персональных данных
                                            </a>
                                        </template>

                                        <!-- для всех остальных чекбоксов -->
                                        <template v-else>
                                            {{ question.name }}
                                        </template>
                                    </label>
                                </div>
                            </div>
                            <!-- <div class="checkbox-container" v-if="consentQuestion">
                                    <input class="checkbox" type="checkbox" :id="consentQuestion.id"
                                        v-model="answers[consentQuestion.id]"
                                        :name="consentQuestion.id"
                                        checked />
                                    <label :for="consentQuestion.id">Я даю согласие на <a
                                            style="color: white;text-decoration:underline;"
                                            @click="openPopup('offer')">сбор и обратботку
                                            персональных
                                            данных</a></label>
                                </div> -->
                            <button @click="confirmRegistration"
                                class="btn-form-submit mt-10 mb-10"
                                :disabled="isSendSms"
                                >{{ isSendSms ? "Отправка..." : "Зарегистрироваться" }}</button>

                        </div>
                    </div>

                </div>
                <div class="main-container-footer">


                    <div class="footer-container">
                        <div class="politics-container">
                            <div>
                                <img src="../assets/img/ballantines-footer-logo.svg" alt="" class="jameson-logo-footer" />
                            </div>
                            <div class="d-flex">
                                <div class="footer-first-block">
                                    <p class="link-text pb-5">{{ config.footer.warningText }}</p>
                                    <a class="link-text" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <div class="footer-second-block">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text">
                                        <a class="footer-main-text" @click="openPopup(item.href)">{{ item.text
                                            }}</a>
                                    </p>
                                </div>
                            </div>
                            <!-- <button @click="openPopup('policy')">Политика конфиденциальности</button>
                            <button @click="openPopup('offer')">Оферта</button>
                            <button @click="openPopup('rules')">Правила</button> -->
                        </div>
                        <div class="social-container">
                            <div class="footer-j-logo">
                                <!-- <img :src="config.footer.logo" class="j-logo-footer" alt="j-logo">
                                    <img src="../assets/img/j-invicible.png" alt="logo" class="j-logo-footer" /> -->
                            </div>
                            <div class="social-icons-container">
                                <!-- <div class="" @click="goTo('https://www.facebook.com/ChivasRegalKazakhstan')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#F2E4B5" />
                                        <path
                                            d="M37.0742 18.1049C37.0742 16.2331 35.4227 14.5815 33.5509 14.5815H19.3475C17.4758 14.5815 15.8242 16.2331 15.8242 18.1049V32.3082C15.8242 34.18 17.4758 35.8315 19.3475 35.8315H26.5043V27.794H23.8618V24.2707H26.5043V22.8393C26.5043 20.417 28.2659 18.3251 30.468 18.3251H33.3307V21.8484H30.468C30.1377 21.8484 29.8074 22.1787 29.8074 22.8393V24.2707H33.3307V27.794H29.8074V35.8315H33.5509C35.4227 35.8315 37.0742 34.18 37.0742 32.3082V18.1049Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                                <div @click="goTo('https://www.instagram.com/ballantines_kz')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="#0000AA"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.3973 21.1698C36.3467 20.0215 36.161 19.232 35.895 18.548C35.6206 17.8218 35.1984 17.1717 34.6452 16.6313C34.1048 16.0825 33.4504 15.656 32.7327 15.3859C32.0447 15.1199 31.2593 14.9342 30.111 14.8835C28.9541 14.8286 28.5869 14.8159 25.6527 14.8159C22.7185 14.8159 22.3512 14.8286 21.1986 14.8792C20.0503 14.9299 19.2609 15.1157 18.5769 15.3816C17.8507 15.656 17.2006 16.0782 16.6601 16.6313C16.1113 17.1717 15.685 17.8261 15.4147 18.5439C15.1487 19.232 14.963 20.0172 14.9123 21.1655C14.8574 22.3224 14.8447 22.6897 14.8447 25.6239C14.8447 28.5581 14.8574 28.9253 14.9081 30.0779C14.9587 31.2263 15.1445 32.0157 15.4106 32.6998C15.685 33.4259 16.1113 34.076 16.6601 34.6164C17.2006 35.1653 17.8549 35.5918 18.5727 35.8619C19.2609 36.1279 20.046 36.3136 21.1945 36.3642C22.3469 36.415 22.7144 36.4276 25.6486 36.4276C28.5828 36.4276 28.95 36.415 30.1026 36.3642C31.2509 36.3136 32.0404 36.1279 32.7243 35.8619C34.1767 35.3003 35.325 34.152 35.8866 32.6998C36.1524 32.0116 36.3383 31.2263 36.3889 30.0779C36.4395 28.9253 36.4522 28.5581 36.4522 25.6239C36.4522 22.6897 36.4479 22.3224 36.3973 21.1698ZM34.4511 29.9935C34.4046 31.049 34.2273 31.6189 34.0796 31.9989C33.7164 32.9404 32.9692 33.6876 32.0277 34.0508C31.6477 34.1985 31.0736 34.3758 30.0223 34.4222C28.8824 34.473 28.5405 34.4855 25.657 34.4855C22.7734 34.4855 22.4272 34.473 21.2915 34.4222C20.236 34.3758 19.6661 34.1985 19.2861 34.0508C18.8176 33.8776 18.3911 33.6032 18.0449 33.2443C17.6861 32.8939 17.4116 32.4717 17.2385 32.0032C17.0907 31.6232 16.9134 31.049 16.8671 29.9978C16.8163 28.8579 16.8038 28.5159 16.8038 25.6323C16.8038 22.7487 16.8163 22.4026 16.8671 21.267C16.9134 20.2115 17.0907 19.6415 17.2385 19.2616C17.4116 18.7929 17.6861 18.3666 18.0492 18.0202C18.3995 17.6614 18.8217 17.387 19.2904 17.214C19.6703 17.0662 20.2446 16.8889 21.2958 16.8424C22.4357 16.7918 22.7777 16.7791 25.6611 16.7791C28.5489 16.7791 28.8908 16.7918 30.0266 16.8424C31.0821 16.8889 31.652 17.0662 32.032 17.214C32.5005 17.387 32.927 17.6614 33.2731 18.0202C33.632 18.3707 33.9064 18.7929 34.0796 19.2616C34.2273 19.6415 34.4046 20.2156 34.4511 21.267C34.5018 22.4069 34.5145 22.7487 34.5145 25.6323C34.5145 28.5159 34.5018 28.8536 34.4511 29.9935Z"
                                            fill="#0000AA" />
                                        <path
                                            d="M25.6543 20.0715C22.5893 20.0715 20.1025 22.5581 20.1025 25.6233C20.1025 28.6884 22.5893 31.175 25.6543 31.175C28.7194 31.175 31.206 28.6884 31.206 25.6233C31.206 22.5581 28.7194 20.0715 25.6543 20.0715ZM25.6543 29.2246C23.6659 29.2246 22.053 27.6118 22.053 25.6233C22.053 23.6347 23.6659 22.022 25.6543 22.022C27.6428 22.022 29.2556 23.6347 29.2556 25.6233C29.2556 27.6118 27.6428 29.2246 25.6543 29.2246Z"
                                            fill="#0000AA" />
                                        <path
                                            d="M32.7222 19.8522C32.7222 20.568 32.1419 21.1483 31.426 21.1483C30.7102 21.1483 30.1299 20.568 30.1299 19.8522C30.1299 19.1363 30.7102 18.5562 31.426 18.5562C32.1419 18.5562 32.7222 19.1363 32.7222 19.8522Z"
                                            fill="#0000AA" />
                                    </svg>
                                </div>
                                <!-- <div @click="goTo('https://www.youtube.com/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.7156 24.4729C36.7156 23.9881 36.6348 23.4225 36.6348 22.776C36.554 22.1295 36.4732 21.4831 36.3924 20.9174C36.2308 20.2709 35.9884 19.7861 35.5035 19.3821C35.0995 18.978 34.5338 18.7356 33.9682 18.6548C32.1096 18.4123 29.3621 18.3315 25.6449 18.3315C21.9278 18.3315 19.0995 18.4123 17.3217 18.6548C16.756 18.7356 16.1904 18.978 15.7863 19.3821C15.3823 19.7861 15.0591 20.2709 14.8974 20.9174C14.7358 21.4831 14.655 22.0487 14.655 22.776C14.5742 23.4225 14.5742 23.9881 14.5742 24.4729C14.5742 24.9578 14.5742 25.5235 14.5742 26.3315C14.5742 27.1396 14.5742 27.7861 14.5742 28.1901C14.5742 28.675 14.655 29.2406 14.655 29.8871C14.7358 30.5336 14.8166 31.18 14.8974 31.7457C15.0591 32.3921 15.3015 32.877 15.7863 33.281C16.1904 33.6851 16.756 33.9275 17.3217 34.0083C19.1803 34.2507 21.9278 34.3315 25.6449 34.3315C29.3621 34.3315 32.1904 34.2507 33.9682 34.0083C34.5338 33.9275 35.0995 33.6851 35.5035 33.281C35.9075 32.877 36.2308 32.3921 36.3924 31.7457C36.554 31.18 36.6348 30.6144 36.6348 29.8871C36.7156 29.2406 36.7156 28.675 36.7156 28.1901C36.7156 27.7053 36.7156 27.1396 36.7156 26.3315C36.7156 25.5235 36.7156 24.877 36.7156 24.4729ZM29.9278 26.978L23.5439 30.9376C23.4631 31.0184 23.3015 31.0992 23.1399 31.0992C22.9783 31.0992 22.8975 31.0992 22.7358 31.0184C22.4934 30.8568 22.3318 30.6144 22.3318 30.2911V22.2911C22.3318 21.9679 22.4934 21.7255 22.7358 21.5639C22.9783 21.4023 23.3015 21.4023 23.5439 21.5639L29.9278 25.5235C30.1702 25.6851 30.3318 25.9275 30.3318 26.1699C30.3318 26.4123 30.1702 26.8164 29.9278 26.978Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                            </div>


                        </div>
                    </div>

                </div>
                <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms"
                    @verifyCode="submitAnswersWithCode" @closePopup="showOtpPopup = false" :success="otpSuccess"
                    :errorMessage="otpError" :loading="otpVerifying" />

            </div>


        </div>
        <ConfirmAge1 v-if="showConfirm" @confirmed="onConfirmed" />
        <transition name="popup">
            <div v-if="isPopupOpen" class="popup-overlay" @click.self="closePopup">
                <div class="popup-content">
                    <div class="popup-header">
                        <span class="header-text">{{ popupTexts[currentPopup].title }}</span>
                        <span class="popup-close-1" @click="closePopup"><svg width="21" height="21" viewBox="0 0 40 40"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.07373 33.4784C-0.348236 34.8712 -0.377256 37.4247 1.10275 38.9046C2.58275 40.3845 5.13648 40.3264 6.52942 38.9336L19.9945 25.4697L33.4597 38.9046C34.9106 40.3555 37.4063 40.3845 38.8863 38.8756C40.3663 37.3957 40.3663 34.9003 38.9154 33.4494L25.4793 20.0145L38.9154 6.5506C40.3663 5.09975 40.3663 2.60428 38.8863 1.12441C37.4063 -0.384476 34.9106 -0.355459 33.4597 1.09539L19.9945 14.5303L6.52942 1.06638C5.13648 -0.326442 2.58275 -0.384476 1.10275 1.09539C-0.377256 2.57526 -0.348236 5.12876 1.07373 6.5506L14.5388 20.0145L1.07373 33.4784Z"
                                    fill="white" />
                            </svg></span>
                    </div>
                    <div class="popup-text-1" v-html="popupTexts[currentPopup].content"></div>
                </div>
            </div>
        </transition>

        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
    </div>


</template>


<style scoped>

.with-padding {
    display: block;
    /* чтобы padding сработал корректно */
    /* margin-top: 25px; */
}

.background-image-mobile-topright {
    position: absolute;
    top: -1px;
    right: 0;
    height: auto;
    /* width: 20%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-topleft {
    position: absolute;
    top: -1px;
    left: 0;
    height: auto;
    /* width: 20%; */
    object-fit: cover;
    z-index: 1;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 4px 5px;
    color: var(--color-primary);
    font-size: 24px;
    font-weight: 700;
    font-family: var(--font-family-bold);
    display: flex;
    flex-direction: row;
}

.third-container ::v-deep .v-select input::placeholder {
    color: var(--color-primary) !important;
    font-weight: 700;
    font-size: 24px;
}

.third-container ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 12px;
    width: 499px !important;
    min-height: 52px;
}

.third-container ::v-deep .v-list-item--dense .v-list-item__title {
    font-size: 24px !important;
    font-weight: 700 !important;
}

input:focus {
    outline: 1px solid #1976d2;
    /* синяя обводка */
    /* или */
    box-shadow: 0 0 5px #1976d2;
}

.third-container ::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: var(--color-primary) !important;
    border-radius: 10px;
}

.third-container ::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 0;
    font-size: 24px;
}

.third-container ::v-deep .v-input__slot {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition-property: height, min-height;
    /* width: 461px; */
}

.third-container ::v-deep .v-input {
    align-items: flex-start;
    display: flex;
    flex: none;
    font-size: 16px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;
    /* height: 48px; */
}

.popup-header {
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.popup-content {
    background-color: var(--color-primary);
    background-size: cover;
    background-position: center;
    padding: 20px;
    width: 100%;
    max-width: 1150px;
    border-radius: 10px;
    /* max-height: 897px; */
    height: 100%;
    max-height: 80vh;
    /* ограничение всей области */
    display: flex;
    flex-direction: column;

}

:deep(.chivas-link) {
    color: var(--color-white);
    /* font-weight: bold; */
    text-decoration: underline;
    transition: color 0.2s;
}

:deep(.chivas-link:hover) {
    color: var(--color-primary);
    text-decoration: underline;
}

.condition-container {
    border-top: 2px solid var(--color-white);
    /* border-bottom: 2px solid #141097; */
}

.second-second-block .condition-container:last-child {
    border-bottom: 2px solid var(--color-white);
}

.condition-text {
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    margin-left: 39.4px;
    font-family: var(--font-family-bold);
}

.condition-text span {
    font-weight: 700;
    font-size: 32px;
    color: var(--color-white);
    margin-bottom: 0px;
    font-family: var(--font-family-bold);
    text-decoration: none;
}

.second-second-block-mobile .condition-container:nth-child(-n+3) {
    border-bottom: none;
}

.error-message {
    color: red;
    font-weight: 300;
    font-size: 14px;
    font-family: var(--font-family);
    min-height: 18px;
}

.form-main-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    max-width: 666px;


}

.form-loading {
    display: flex;
    justify-content: center;
    align-items: center;
}

.form-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-error-text {
    font-weight: 700;
    font-size: 16px;
    color: #ad0202;
    margin-bottom: 0px;
    font-family: var(--font-family-bold);
}

.registration-body-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border-radius: 20px; */
    padding: 0px 33.33px 0px;
    /* max-width: 1033px;
    min-width: 320px; */
    height: 100%;
    /* background: #f2e4b5; */
    margin: auto;
}



.btn-form-submit,
.btn-form-submit-mobile {
    /* border-radius: 10px; */
    /* padding: 11px 42px; */
    height: 59px;
    background: var(--color-primary);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 24px;
    color: var(--color-white);
    cursor: pointer;
    box-shadow: 0 4px 0 var(--color-primary-dark);
    text-transform: uppercase;
    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении (быстрее, чем возврат) */
.btn-form-submit:hover,
.btn-form-submit-mobile:hover {
    background: var(--color-primary);
    transform: translateY(-2px);
    box-shadow: 0 6px 0 var(--color-primary-dark);

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-form-submit:active,
.btn-form-submit-mobile:active {
    background: var(--color-primary);;
    transform: translateY(2px);
    box-shadow: 0 2px 0 var(--color-primary-dark);
    transition: all 0.1s ease-in;
}

.btn-form-submit {
    border-radius: 10px;
    padding: 0px 40px;
    /* width: 226px; */
     text-transform: uppercase;
    height: 66px;
    background: var(--color-primary);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 24px;
    color: var(--color-white);
}

.btn-form-submit-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 360px; */
    height: 51px;
    background: var(--color-primary);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-md);
    color: var(--color-white);
}

.position-relative {
    position: relative;
}

.popup-enter-active,
.popup-leave-active {
    animation: fadeIn 0.3s ease-in-out, slideIn 0.3s ease-in-out;
}

.popup-leave-active {
    animation: fadeOut 0.3s ease-in-out, slideOut 0.3s ease-in-out;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}



.popup-container {
    background: #154734;
    padding: 20px;
    text-align: center;
    position: relative;
    border-radius: 30px;
    width: 594px;
    height: 421px;
}

.popup-close {
    position: absolute;
    top: 25px;
    right: 27px;
    background: none;
    border: none;
    color: #f2e4b5;
    cursor: pointer;
}

.popup-logo {
    width: auto;
    height: auto;
    margin-bottom: 38px;
    margin-top: 10px;
}

.popup-title {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 40px;
    text-transform: uppercase;
    text-align: center;
    color: #f2e4b5;
    margin-bottom: 31px;
}

.popup-text {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 36px;
    text-align: center;
    color: #f2e4b5;
    max-width: 346px;
    width: 100%;
    margin-bottom: 0px;
    line-height: 1.2;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-20px);
        opacity: 0;
    }
}
::v-deep .theme--light.v-icon {
    color: var(--color-primary) !important; 
}
.social-icons-container {
    cursor: pointer;
}

.social-icons-container svg {
    width: 48px;
    height: 48px;
    transition: transform 0.3s ease;
}

.social-icons-container svg:hover {
    transform: scale(1.1);
}

.social-icons-container {
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
}

.j-logo-footer {
    width: 118px;
    height: 155px;
}

.politics-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 253px;
}

.main-container-footer {
    padding-left: clamp(16px, 10vw, 195.74px);
    padding-right: clamp(16px, 9.5vw, 184.11px);
    padding-top: clamp(40px, 6.76vh, 73px);
    padding-bottom: clamp(40px, 10.5vh, 101px);
    background-color: var(--color-primary-dark);

}

.footer-j-logo {
    text-align: center;
}

.social-container {
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
    /* flex-wrap: wrap; */
    justify-content: space-between;
    /* margin-top: auto; */

    height: 242px;
}

.footer-main-text {
    font-family: var(--font-family-regular);;
    font-weight: 500;
    font-size: clamp(var(--font-size-md), 2.5vw, var(--font-size-lg));
    line-height: 175%;
    color: #FFFFFF;
    margin-bottom: 0;
    text-decoration: underline;
}

.link-text {
    font-family: var(--font-family-regular);
    font-weight: 390;
    font-size: var(--font-size-lg);
    color: #FFFFFF;
    margin-bottom: 0px;
}

.footer-first-block {
    max-width: clamp(240px, 28.04vw, 476px);
    margin-right: clamp(20px, 3.13vw, 60px);
}

.footer-container {

    display: flex;
    justify-content: space-between;
    align-items: center;
}

.jameson-logo-footer {
    width: clamp(150px, 12.95vw, 228px);
    /* 268px ≈ 13.95vw на экране 1920px */
    height: clamp(130px, 5.93vh, 148px);
    /* 64px ≈ 5.93vh на экране 1080px */
}

.btn-green {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 226px; */
    height: 59px;
    background: #141097;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 20px;
    color: #f2e4b5;
}

.checkbox {
    /* appearance: none; */
    /* убираем стандартный стиль браузера */
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-black);
    background-color: white;
    margin-right: 6px;
}

.checkbox-mobile {
    /* appearance: none; */
    /* убираем стандартный стиль браузера */
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-black);
    background-color: white;
    margin-left: 20px;
}

.checkbox-container {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    flex-direction: column;
}

.checkbox-container label {
    color: black;
    font-family: var(--font-family-bold);
}

.checkbox-container router-link {
    color: black;
}

.btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.input-body {
    border: 1px solid var(--color-primary);
    color: var(--color-primary);
    border-radius: 10px;
    padding: 15px 15px;
    width: 499px;
    height: 59px;
    font-size: var(--font-size-lg);
    font-family: var(--font-family-bold);
    font-weight: 700;
    /* margin-left: auto; */
    /* Выравнивание поля ввода вправо */
}



.input-body::placeholder {
    color: var(--color-primary);
    /* Задайте нужный цвет */
    font-size: 24px;
     font-weight: 700;
    font-family: var(--font-family-bold);
    opacity: 1;
    /* Убедитесь, что текст полностью видим */
}

.input-name {
    font-family: var(--font-family);
    font-weight: 500;
    font-size: 24px;
    color: var(--color-white);
    margin-right: 20px;
    margin-bottom: 0px;
    /* Отступ между текстом и полем ввода */
    white-space: nowrap;
    /* Предотвращаем перенос текста */
}

.form-container {
    display: block;
    align-items: stretch;
    width: 100%;
    /* Растягиваем контейнер */
}

.form-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 17px;
    /* расстояние между инпутами */
    max-width: 501px;
}

.text-title {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 48px;
    text-transform: uppercase;
    text-align: center;
    color: var(--color-primary);
    margin-bottom: 0;
    text-transform: uppercase;
    line-height: 1.2;
}

.title-container {
    /* width: 798px; */
    /* margin: auto; */
    padding-top: 38px;
    padding-bottom: 52px;
}

.registration-body-container {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    /* border-radius: 20px; */

    /* max-width: 1033px;
    min-width: 320px; */
    /* height: 100%; */

    /* background: #f2e4b5; */
    margin: auto;
}

.third-container {
    background-color: #FFFFFF;
    position: relative;
    /* background-image: url('../assets/img/ballantines-form-bg.png');
    background-size: cover;
    background-position: center; */
    /* height: 120vh; */
    /* padding: 142px 183.66px 127.15px 209.54px; */

}

.second-first-block {
    padding-top: 94px;
}

.number {
    color: var(--color-white);
    font-size: 96px;
    font-weight: 400;
    margin-bottom: 0px;
    font-family: var(--font-family-regular);
}

.second-block-description span {
    color: var(--color-white);
    font-weight: 700;
    font-size: 32px;
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.2;
    text-transform: uppercase;
    font-family: var(--font-family);
}

.second-first-container {
    margin: 0px 183px 0px;
}

.second-block-title {
    color: var(--color-white);
    font-weight: 400;
    font-size: 96px;
    text-transform: uppercase;
    margin-bottom: 0px;
    font-family: var(--font-family-cyr);

}

.second-second-block {
    padding-bottom: 5.1979166667vw;
    max-width: 1075px;
}

.second-contaier {
    background-image:
        var(--bg-url);
    background-size: cover;
    background-position: center;
    height: 100%;
}

.big-img-first-block {
    max-width: 789.74px;
    max-height: 1046.18px;
    width: 100%;
    object-fit: cover;
    border-radius: 20px;
    /* transform: rotate(-7deg); */
}

.description-first-block {
    color: var(--color-white);
    font-weight: 500;
    font-size: 48px;
    line-height: 1.2;
    margin-top: 24px;
    /* max-width: 688px; */
    text-transform: uppercase;
    max-width: 653px;
    font-family: var(--font-family);
}

.description-first-block-small {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-white);
    line-height: 1.2;
    margin-top: 24px;
    max-width: 688px;
    font-family: var(--font-family-medium);
}

.title-first-block span {
    text-transform: uppercase;
}

.title-first-block {
    color: var(--color-white);
    font-weight: 500;
    font-size: 128px;
    line-height: 100%;
    line-height: 1.2;
    margin-top: 74.94px;
    font-family: var(--font-family);

}

.first-block {
    display: flex;
    flex-direction: column;
    padding: 100px 183.66px 127.15px 182px;

}

.jameson-invisible {
    width: 131px;
    height: 172px;
    margin-left: 54.04px;
}

.jameson-logo {
    width: 333px;
    height: 226px;
    margin-bottom: 18px;
}

.first-container {
    background-image: url('../assets/img/Ball-back-first.jpg');
    background-size: cover;
    background-position: center;
    /* height: 120vh; */
    /* padding: 86px 183.66px 127.15px 182px; */
    /* display: flex;
    justify-content: space-between;
    align-items: center; */
}

.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: var(--font-family);
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}



input:focus {
    outline: 1px solid #1976d2;
    /* синяя обводка */
    /* или */
    box-shadow: 0 0 5px #1976d2;
}

.header-text {
    font-family: var(--font-family);
    font-weight: 500;
    font-size: 32px;
    text-transform: uppercase;
    color: #FFFFFF;
}

.popup-close-1 {
    /* font-size: 20px; */
    cursor: pointer;
}

.popup-text-1 {
    font-family: var(--font-family-medium);
    font-weight: 300;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 1.6;
    white-space: pre-line;
    padding: 0 15px;
    overflow-y: auto;
    /* скролл только текста */
    flex: 1;
}

.popup-text-1::-webkit-scrollbar {
    width: 8px;
    /* толщина */
}

/* Ползунок */
.popup-text-1::-webkit-scrollbar-thumb {
    background-color: white;
    /* цвет (как на картинке) */
    border-radius: 10px;
    /* закругления */
}

/* Фон скроллбара */
.popup-text-1::-webkit-scrollbar-track {
    background: transparent;
    /* прозрачный трек */
}

.popup-close {
    margin-top: 10px;
    align-self: flex-end;
}

.custom-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* стили для label */
.checkbox-label {
    /* display: flex;
  align-items: flex-start; */
    cursor: pointer;
    font-size: 20px;
    line-height: 1.3;
    font-family: var(--font-family-bold);
    font-weight: 700;
    /* твой кастомный шрифт */
    position: relative;
    padding-left: 24px;
    /* отступ под квадратик */
}

/* кастомный квадратик */
.checkbox-label::before {
    content: "";
    position: absolute;
    left: -8px;
    top: 2px;
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-black);
    border-radius: 2px;
    /* убери, если нужен квадрат без скруглений */
    background-color: #FFFFFF;
}

.checkbox-label::after {
    content: "";
    position: absolute;
    left: 0px;
    top: 5px;
    width: 6px;
    height: 10px;
    border: solid transparent;
    /* по умолчанию невидимая */
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: border-color 0.2s ease;
}

/* при checked — черный фон и белая галочка */
.custom-checkbox:checked+.checkbox-label::before {
    background-color: var(--color-primary);
}

.custom-checkbox:checked+.checkbox-label::after {
    border-color: #FFFFFF;
    /* галочка белая */
}

/* ---------------------------------------MOBILE */

.third-container-mobile .city-select-container ::v-deep .v-select input::placeholder {
    font-size: 14px !important;
    /* нужный вам размер */
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    white-space: normal !important;
    word-break: break-word;
}

.third-container-mobile ::v-deep .v-select.v-text-field:not(.v-text-field--single-line) input {
    margin-top: 0;
    text-align: left;
}

.third-container-mobile ::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: 46px !important;
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    font-size: 16px !important;
    /* нужный вам размер */
}

.third-container-mobile ::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: var(--color-primary) !important;
    border-radius: 6.64px;
}

.third-container-mobile ::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 0;
    font-size: 18px;
}

.third-container-mobile ::v-deep .v-input__slot {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition-property: height, min-height;
    width: 461px;
}

.third-container-mobile ::v-deep .v-input {
    align-items: flex-start;
    display: flex;
    flex: none;
    font-size: 16px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;
    height: 50px;
}

.third-container-mobile {
    /* background-image: url('../assets/img/ballantines-form-bg.png');
    background-size: auto;
    background-position: center; */
    background-color: #FFFFFF;
    position: relative;
    height: 100%;
    padding: 40px 0px 30.15px 0px;

}



.third-container-mobile ::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 4px 3px;
    color: var(--color-primary);
    font-size: 16px;
    font-family: var(--font-family-bold);
    font-weight: 700;
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    color: var(--color-primary) !important;
    font-weight: 700;
    font-size: 16px;


}

.third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 12px;
    min-width: 325px !important;
    width: 100% !important;
}

.third-container-mobile ::v-deep .v-list-item--dense .v-list-item__title {
    font-size: 18px !important;

}

.second-block-title-mobile {
    color: var(--color-white);
    font-weight: 400;
    font-size: 40px;
    text-transform: uppercase;
    margin-bottom: 12px;
    text-align: left;
    font-family: var(--font-family-cyr);
}

.second-block-description-mobile span {
    font-family: var(--font-family);
    color: #141097;
    font-weight: 700;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    line-height: 28px;
    text-transform: uppercase;
    text-align: left;
}

.second-first-container-mobile {
    margin: 0px 20px 0px;
}

.number-mobile {
    color: var(--color-white);
    font-size: 40px;
    font-weight: 400;
    margin-bottom: 0px;
    font-family: var(--font-family-regular);
}

.condition-text-mobile {
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    margin-left: 39.4px;
    font-family: var(--font-family-bold)
}

.condition-text-mobile span {
    font-weight: 700;
    font-size: 16px;
    color: var(--color-white);
    margin: 25px 0;
    font-family: var(--font-family-bold);
}

.text-title-mobile {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 40px;
    line-height: 100%;
    text-transform: uppercase;
    text-align: center;
    color: var(--color-primary);
    margin-bottom: 0;
    word-wrap: break-word;
}

.registration-body-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border-radius: 20px; */
    padding: 0px 33.33px 0px;
    /* max-width: 1033px;
    min-width: 320px; */
    height: 100%;
    /* background: #f2e4b5; */
    margin: auto;
}

.footer-container-mobile {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
}

.no-truncate .v-select__selection {
    white-space: normal !important;
    text-overflow: initial !important;
    overflow: visible !important;
}


.first-block-logo-mobile {
    max-width: 320.11px;
    height: 47.02px;
    width: 100%;
    margin-bottom: 5.94px;
}

.first-container-mobile {
    background-image: url('../assets/img/Ball-back-first.jpg');
    background-size: cover;
    background-position: center;
    /* height: 100vh; */
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.second-first-block-mobile {
    padding-top: 32px;
}

.second-second-block-mobile {
    padding-bottom: 25px;
}

.second-second-block-mobile .condition-container:nth-child(-n+3) {
    border-bottom: none;
    max-width: 520px;
}

.logo-container-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    /* height: 200px; */
}

.logo-container-footer-2 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 46px;
}

.link-text-mobile {
    font-weight: 400;
    font-size: 20px;
    color: var(--color-white);
    margin-bottom: 0px;
    font-family: var(--font-family-regular);
}

.politics-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.social-container-mobile {
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
    /* flex-wrap: wrap; */
    justify-content: space-between;
    margin-top: 47px;
}

.main-container-footer-mobile {
    padding: 30px 15px;
    background-color: var(--color-primary);

}

.input-body-mobile {
    border: 1px solid var(--color-primary);
    border-radius: 10px;
    padding: 15px 14px;
    min-width: 325px;
    width: 100%;
    height: 50px;
    font-size: var(--font-size-xs);
    color: var(--color-primary);
    /* Текст ломает адаптивные инпуты и селекты очень странное поведение */
    font-family: var(--font-family-bold);
    font-weight: 700;
    /* margin-left: auto; */
    /* Выравнивание поля ввода вправо */
}

.input-body-mobile::placeholder {
    color: var(--color-primary);
    /* Задайте нужный цвет */
    font-size: 16px;
    font-family: var(--font-family-bold);
    opacity: 1;
    font-weight: 700;
    /* Убедитесь, что текст полностью видим */
}

.title-first-block-mobile {
    color: var(--color-white);
    font-weight: 500;
    font-size: 64px;
    line-height: 100%;
    text-transform: uppercase;
    margin-top: 24.08px;
    font-family: var(--font-family);
    text-align: left;
}

.description-first-block-mobile {
    color: var(--color-white);
    font-weight: 500;
    font-size: 32px;
    text-transform: uppercase;
    margin-top: 24px;
    max-width: 360px;
    font-family: var(--font-family);
    text-align: left;
}

.description-first-block-small-mobile {
    font-weight: 500;
    font-size: 13px;
    color: #fff;
    line-height: 1.2;
    margin-bottom: 30px;
    max-width: 360px;
    font-family: var(--font-family-medium);
}

.jameson-logo-mobile {
    width: 192.11px;
    height: 168.02px;
    /* margin-bottom: 18px; */
}

.big-img-first-block-mobile {
    /* max-width: 229.74px;
    max-height: 272.18px; */
    width: 100%;
    object-fit: cover;
    border-radius: 5px;
}

.third-container-mobile ::v-deep .v-select__selections {
    display: flex;
    /* оставляем flex */
    align-items: center;
  flex-direction: column;
    /* выравнивание по центру */
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /* ... в конце */
}

.third-container-mobile ::v-deep .v-select__selections span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
}

/* .third-container-mobile ::v-deep .v-select.v-input {
  width: 100% !important;
  max-width: 325px; 
} */
.third-container-mobile ::v-deep .v-select input::placeholder {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: block;
    width: 100%;
}

.third-container-mobile ::v-deep .v-select input {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    width: 100% !important;
    display: block;
}

@media screen and (max-width: 1250px) {
    .checkbox-label {
        font-size: 16px;
    }
    /* кастомный квадратик */
    .checkbox-label::before {
        left: 0px;
        width: 15px;
        height: 15px;
    }

    .checkbox-label::after {
        left: 5px;
        top: 3px;
    }

    .checkbox-container label {
        color: black;
        text-align: left;
        font-size: 16px;
        font-weight: 500;
    }

    .third-container {
        padding: 35px 0 0;
    }

    .popup-close-1 {
        font-size: 16px;
    }

    .title-container {
        padding-bottom: 39px;
        padding-top: 0px;
    }

    .form-container {
        justify-content: center;
          flex-direction: column;
    }

    .checkbox-container label {
        color: white;
        text-align: left;
    }

    .input-body {
        text-align: left;
    }

    .input-body-mobile {
        text-align: left;
    }

    .footer-second-block {
        margin-top: 15px;
        text-align: center;
    }

    .footer-first-block {
        text-align: center;
        width: 100%;
        margin-right: 0px;
        max-width: 440px;
        margin-top: 30px;
    }

    .footer-main-text {
        padding: 5px 0;
    }

    .first-block {
        padding: 25px 0 0 0;
        display: flex;
        align-items: center;
    }

    .popup-header {
        padding: 5px 0;
    }

    .header-text {
        font-family: var(--font-family);
        font-weight: 500;
        font-size: 20px;
        text-transform: uppercase;
        color: #FFFFFF;
    }

    /* Текст внутри */
    .popup-text-1 {
        font-family: var(--font-family-medium);
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 1.6;
        white-space: pre-line;
        padding: 0;
        overflow-y: auto;
        /* скролл только текста */
        flex: 1;
    }

    .popup-close-1 {
        font-size: 16px;
    }
}

@media screen and (max-width: 566px) {
    /* .checkbox-label::before {
        margin-top: 10px;
    } */

    .checkbox-label::after {
        left: 5px;
        /* top: 13px; */
    }
}

@media (max-width: 1617px) and (min-width: 1250px) {
    .first-block {
        display: flex;
        flex-direction: column;
        padding: 86px 120.66px 27.15px 120px;
    }
    .block-info {
        padding: 40px 120px
    }

    .title-first-block {
        color: var(--color-white);
        font-weight: 500;
        /* font-size: 40px; */
        font-size: 6.5633333333vw;
        line-height: 1.2;
        margin-top: 24.94px;
        font-family: var(--font-family);
        max-width: 730px;
    }

    .description-first-block {
        max-width: 600px;
    }

    .second-first-container {
        margin: 0 120px;
    }
}

@media screen and (max-width: 376px) {
    .form-container {
        max-width: 228px;
    }

    .additional {
        padding: 30px 20px 0px 30px;
    }

    .error-message {
        font-size: 12px;
    }

    .input-body-mobile {
        min-width: 100%;
    }

    .addition-height {
        height: 50px;
    }

    .third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
        max-width: 228px !important;
        min-width: 100% !important;
    }
        /* .third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
        width: 100%;
        max-width: 100%;
    } */
    .input-body-mobile {
        max-width: 228px !important;
        min-width: 100% !important;
    }
    /* .first-block {
        padding: 15px;
    } */

}

@media screen and (orientation: landscape) {
    .second-contaier-mobile {
        background-image: url('../assets/img/second-block-bg.jpg');
        background-size: cover;
        background-position: center;
        /* height: 100vh; */
    }


}
</style>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Otp from '@/components/otp.vue';
import ConfirmAge1 from "@/components/age-confirm.vue";
import config from "@/config/pageConfig.json";
import {
    initLanding,
    trackFormStart,
    trackFormSubmit,
    trackFormError,
    trackRegistrationSuccess,
    trackVirtualPageView
} from "@/utils/analytics";
export default {

    directives: { mask },
    name: "SocialLead",
    components: {
        Otp,
        ConfirmAge1
    },
    data() {
        return {
            showConfirm: true,
            isMobile: window.innerWidth < 1264,
            phone: '',
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
            checkbox: false,
            email: '',
            name: '',
            city: '',
            instagram: '',
            product: '',
            surname: '',
            showOtpPopup: false,
            snackbar: false,
            message: "",
            otp: '',
            expectedOtp: '1111',
            loading: false,
            smsTimer: 60, // 60 секунд
            smsTimerInterval: null,
            isSendSms: false,
            isPopupOpen: false,
            currentPopup: null,
            showPopup: false,
            formSchema: null,
            otpSuccess: false,
            otpVerifying: false,
            isLoadingForm: true,
            formError: false,
            otpError: "",
            otpErrorSms: false,
            formData: {},
            errors: {},
            touched: {},
            popupTexts: {
                policy: {
                    title: "Политика конфиденциальности",
                    content: `1. Общие положения
                        Настоящая политика конфиденциальности (далее - Политика) составлена в соответствии с требованиями Закона Республики Казахстан от 21 мая 2013 года №94-V «О персональных данных и их защите», иных нормативно-правовых актов, регулирующих требования к сбору, хранению и обработки персональных данных, и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые ТОО «Перно Рикар Казахстан» (далее - Компания).
                        1.1. Компания ставит своей первостепенной целью безопасность и конфиденциальность предоставленной пользователями веб-сайта https://ballantines.prk-events.kz/registration (далее – «Веб-сайт») личной информации. В соответствии с нормативными требованиями и стандартами, Настоящая Политика, основываясь на требованиях законодательства Республики Казахстан в области сбора, обработки, хранения и защиты персональных данных, подробно описывает личную информацию, которую Компания собирает, цели ее сбора и обработки, а также ваши права в отношении персональных данных. 
                        1.2. Настоящая Политика применяется в отношении сбора, обработки, хранения, а также передачи персональных данных, которые Компания может получить о пользователях Веб-сайта.

                        2. Основные понятия, используемые в Политике
                        2.1. Компания - ТОО «Перно Рикар Казахстан», место нахождения: А26T8F4, Республика Казахстан, г. Алматы, Медеуский район, ул. Рубинштейна, дом 48.
                        2.2. Автоматизированная обработка персональных данных - обработка персональных данных с использованием средств вычислительной техники.
                        2.3. Блокирование персональных данных - временное прекращение обработки персональных данных.
                        2.4. Веб-сайт – интернет-сайт, расположенный по следующему адресу https://ballantines.prk-events.kz/registration.
                        2.5. Информационная система персональных данных - совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств.
                        2.6. Обезличивание персональных данных - действия, в результате которых невозможно определить принадлежность персональных данных конкретному субъекту без использования дополнительной информации.
                        2.7. Обработка персональных данных - любое действие (операция) или совокупность действий с персональными данными, включая:
                        •	Сбор;
                        •	Запись;
                        •	Систематизацию;
                        •	Накопление;
                        •	Хранение;
                        •	уточнение (обновление, изменение);
                        •	извлечение;
                        •	использование;
                        •	передачу (в том числе трансграничную передачу);
                        •	обезличивание;
                        •	блокирование;
                        •	удаление;
                        •	уничтожение.
                        2.8. Персональные данные - личные сведения, относящиеся к определенному или определяемому субъекту персональных данных.
                        2.9. Пользователь - любой зарегистрированный пользователь Веб-сайта.

                        3. Порядок применения настоящей Политики
                        3.1. Политика о конфиденциальности подлежит применению в отношении персональных данных Пользователя, которые Компания собирает и/или обрабатывает и/или использует иным законным образом. 
                        3.2. Используя Веб-сайт и предоставляя свои персональные данные, Пользователь подтверждает и соглашается с условиями настоящей Политики.

                        4. Порядок связи Пользователя с Компанией
                        4.1. По любым вопросам, касающимся персональных данных, Пользователь может обратиться к Компании простым письменным обращением по следующему адресу: А26T8F4, Республика Казахстан, г. Алматы, Медеуский район, ул. Рубинштейна, дом 48, или посредством электронной почты: Info.kz@pernod-ricard.com.
                        5. Цели сбора персональных данных Пользователя
                        5.1. Персональные данные Пользователя собираются и обрабатываются Компанией в следующих законных целях:
                        5.1.1. Предоставление доступа к Веб-сайту и создание профиля пользователя;
                        5.1.2. Обеспечение доступа к функциям Веб-сайта (например, доступ к онлайн-контенту, участие в тренингах, регистрация на мероприятия), пользование Веб-сайтом и возможность принятия участия в активациях и мероприятиях, проводимых Компанией; 
                        5.1.2. информирование и приглашения на мероприятия, проводимые Компанией, а также предоставление информации о Компании и ее аффилированных лицах, о товарах и услугах Компании, об активностях Компании, о научных исследованиях или иных данных в отношении товаров или услуг Компании; 
                        5.1.3. приглашения к участию в активностях, опросах и исследованиях, программах, в том числе программах лояльности Компании или ее партнеров, включая исполнения обязательств Компании и/или партнеров по таким программам;
                        5.1.4. пополнение CRM-базы путем добровольного предоставления персональных данных пользователями для участия в маркетинговых активностях, проводимых в отношении товарных знаков продукции.
                        5.1.5. улучшения качества товаров и услуг, улучшения опыта взаимодействия потребителя с Компанией, разработки коммуникаций и сервисных решений.
                        5.1.6. отправление административных уведомлений и сервисных сообщений.
                        5.1.7. адаптация контента Пользователя Веб-сайта.

                        6. Перечень собираемых и обрабатываемых персональных данных Пользователя
                        6.1. В целях использования функционала Веб-сайта Пользователь предоставляет следующие персональные данные:
                        6.1.1. Фамилия, имя и отчество (при наличии) в соответствии с документом, удостоверяющим личность;
                        6.1.2. Дата рождения Пользователя, в целях подтверждение достижения им возраста 21 года;
                        6.1.3. Номер контактного мобильного телефона, зарегистрированного на имя Пользователя (11 цифр); 
                        6.1.4. Город проживания;
                        6.1.5. Пол Пользователя;
                        6.1.6. Адрес электронной почты (e-mail) Пользователя.

                        7. Обработка персональных данных Пользователя

                        7.1. Обработка персональных данных будет осуществляться Компанией и третьими лицами (партнерами, операторами мобильной связи и пр.), действующими по поручению/заданию Компании, с соблюдением принципов и правил, предусмотренных Законом Республики Казахстан “О персональных данных и их защите” и иными применимыми нормативными актами (далее - Закон «О персональных данных»). 
                        7.2. Под обработкой персональных данных понимается любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), трансграничную передачу, обезличивание, блокирование, удаление, уничтожение персональных данных Пользователя.

                        8. Безопасность персональных данных Пользователя

                        8.1. Компания, третьи лица (партнеры), действующие по поручению/заданию Компании, гарантируют необходимые меры защиты персональных данных от несанкционированного доступа. Все персональные данные, сообщенные Пользователем, будут храниться и обрабатываться Компанией, третьими лицами (партнерами), действующими по поручению/заданию Компании, в соответствии с действующим законодательством РК, иными местными и международными применимыми нормами, и с соблюдением гарантий, указанных в настоящей Политики. 
                        8.2. Компания и иные партнеры, действующие по поручению/заданию Компании, обязуются соблюдать следующие правила и предоставляют Пользователю следующие гарантии в отношении обработки его персональных данных:
                        8.2.1. обеспечить обработку персональных данных с соблюдением всех применимых требований законодательства РК в области защиты персональных данных, в том числе с соблюдением принципов, требований, обязательств оператора персональных данных, установленных Законом «О персональных данных»;
                        8.2.2.  обрабатывать персональные данные только в объеме и в целях, указанных в настоящей Политике, а также в целях дальнейшей коммуникации с Пользователем посредством электронной почты и в социальных сетях, мобильной связи. Использование и иные виды обработки персональных данных в целях информирования субъектов персональных данных о Продукции или услугах Компании, а также в любых иных целях будет осуществляться только в объеме и в случаях, предусмотренных Законом «О персональных данных»;
                        8.2.3.  в случае если Компания в целях исполнения своих обязательств перед Пользователем должна передать или иным образом раскрыть персональные данные Пользователя третьим лицам, осуществлять указанные действия с соблюдением требований Закона «О персональных данных»;
                        8.2.4. нести ответственность за охрану и обеспечение безопасности и конфиденциальности персональных данных Пользователя при их обработке в соответствии с требованиями законодательства РК. 
                        8.2.5. хранить и обрабатывать персональные данные Пользователя только в течение срока действия данного им Согласия на сбор и обработку персональных данных.


                        9. Основные права и обязанности Компании
                        9.1. Компания имеет право:
                        9.1.1. получать от Пользователя достоверную информацию;
                        9.1.2. самостоятельно определять необходимые меры защиты персональных данных.
                        9.2. Компания обязана
                        9.2.1. предоставлять Пользователю по его запросу полную и достоверную информацию об обработке его персональных данных;
                        9.2.2. организовывать обработку персональных данных в соответствии с законодательством Республики Казахстан, иными локальными и международными применимыми нормами;
                        9.2.3. принимать необходимые правовые, организационные и технические меры для защиты персональных данных;
                        9.2.4. публиковать настоящую Политику или обеспечивать свободный доступ к ней;
                        9.2.5. прекращать обработку и уничтожать персональные данные в случаях, предусмотренных законодательством Республики Казахстан.

                        10. Права и обязанности Пользователя
                        10.1. Пользователь имеет право:
                        10.1.1. получать информацию о своих персональных данных и их обработке;
                        10.1.2. требовать уточнения, блокирования или уничтожения персональных данных;
                        10.1.3. отзывать согласие на обработку персональных данных;
                        10.1.4. обжаловать действия Компании в уполномоченном государственном органе или в судебном порядке.
                        10.1.5. Пользователь может актуализировать свои персональные данные, направив запрос на электронную почту: Info.kz@pernod-ricard.com с пометкой «Актуализация персональных данных».
                        10.2 Пользователь обязан:
                        10.2.1. предоставлять достоверные данные о себе;
                        10.2.2. своевременно сообщать об изменении своих персональных данных.

                        11.  Принципы обработки персональных данных Пользователя
                        11.1. Обработка персональных данных осуществляется на основе следующих принципов:
                        11.1.1. законности и справедливости;
                        11.1.2. обработки только для конкретных и законных целей;
                        11.1.3. недопущения избыточности персональных данных;
                        11.1.4. обеспечения точности и актуальности персональных данных;
                        11.1.5. хранения персональных данных не дольше, чем этого требуют цели обработки.

                        12. Заключительные положения
                        12.1. Пользователь может получить разъяснения по вопросам обработки персональных данных, направив запрос на: Info.kz@pernod-ricard.com 
                        12.2. Политика действует бессрочно. Компания вправе в любое время и по любому основанию вносить изменения в настоящую Политику.
                        12.3. Актуальная версия Политики размещается по адресу: https://ballantines.prk-events.kz/registration.`,
                },
                offer: {
                    title: "СОГЛАСИЕ НА СБОР И ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ (для клиентов и потенциальных клиентов)",
                    content: `Я подтверждаю, что достиг возраста 21 года и более и даю ТОО «Перно Рикар Казахстан» (БИН 050840001045) (далее - Компания), а также его работникам и третьим лицам-соисполнителям по заключенным между ними договорам, свое согласие на сбор, обработку, хранение, распространение и передачу, в том числе трансграничную передачу (без дополнительных уведомлений) моих персональных данных, относящихся исключительно к перечисленным ниже категориям персональных данных: 
                            1) ФИО
                            2) Город проживания
                            3) Мобильный телефон
                            4) E-mail
                            5) Возраст
                            6) Пол

                            Согласованная цель сбора и обработки персональных данных:
                            - предоставление доступа к Веб-сайту и создание профиля пользователя;
                            - обеспечение доступа к функциям Веб-сайта (например, доступ к онлайн-контенту, участие в тренингах, регистрация на мероприятия), пользование Веб-сайтом и возможность принятия участия в активациях и мероприятиях, проводимых Компанией; 
                            - информирование и приглашения на мероприятия, проводимые Компанией, а также предоставление информации о Компании и ее аффилированных лицах, о товарах и услугах Компании, об активностях Компании, о научных исследованиях или иных данных в отношении товаров или услуг Компании; 
                            - приглашения к участию в активностях, опросах и исследованиях, программах, в том числе программах лояльности Компании или ее партнеров, включая исполнения обязательств Компании и/или партнеров по таким программам;
                            - пополнение CRM-базы путем добровольного предоставления персональных данных пользователями для участия в маркетинговых активностях, проводимых в отношении товарных знаков продукции.
                            - улучшения качества товаров и услуг, улучшения опыта взаимодействия потребителя с Компанией, разработки коммуникаций и сервисных решений.
                            - направление административных уведомлений и сервисных сообщений.
                            - адаптация контента Пользователя Веб-сайта.

                            Я даю согласие на использование персональных данных исключительно в вышеуказанных целях, а также на обработку персональных данных и их трансграничную передачу на всех электронных носителях, используемых для вышеуказанной цели. Настоящее согласие предоставляется мной на осуществление действий в отношении моих персональных данных, которые необходимы для достижения указанных выше целей, включая (без ограничения) сбор, систематизацию, накопление, хранение, уточнение (обновление, изменение), использование, передачу третьим лицам для осуществления действий по обмену информацией, обезличивание, блокирование персональных данных, трансграничную передачу персональных данных на территорию любого государства, в том 
                            числе не обеспечивающего защиту персональных данных, распространение моих персональных данных в общедоступных источниках, а также осуществление любых иных действий, предусмотренных действующим законодательством Республики Казахстан.

                            Я предоставляю согласие на контактирование со мной для вышеуказанных целей путем осуществления разговора, телефонных звонков, направления мне уведомлений с использованием почты, телефона (также SMS), социальных сетей и/или мессенджеров, вебсайтов, электронной почты, электронных информационных ресурсов и иных информационных систем и мобильных приложений.

                            Я предоставляю Компании право хранить мои Персональные данные в рамках срока, установленного Компанией для достижения вышеуказанных целей, передавать мои Персональные данные за пределы территории Казахстана и обрабатывать их вне Казахстана (трансграничная передача), распространять (передавать) мои Персональные данные аффилированным лицам и партнерам (контрагентам) Компании, а также партнерам (контрагентам) аффилированных лиц Компании (я подтверждаю, что при этом не затрагиваются интересы других лиц), искать и производить сбор дополнительной информации обо мне в социальных сетях или иных публичных источниках самостоятельно и/или с привлечением третьих лиц. Я подтверждаю свое согласие на признание собранных Компанией Персональных данных обо мне в социальных сетях или иных публичных источниках самостоятельно и/или с привлечением третьих лиц общедоступными. Настоящим подтверждаю, что предоставленные мной данные не являются данными ограниченного доступа и на них в соответствии с законодательством Республики Казахстан не распространяются положения о данных ограниченного доступа.

                            Я уведомлен, что Компания не будет публиковать мои Персональные данные в общедоступных источниках, за исключением случаев публикации моих фамилии, имени, отчества, адреса электронной почты и (или) имени пользователя в социальных сетях и приложениях для обмена сообщениями при моем участии в активностях Компании. Я проинформирован, что Компания гарантируют обработку моих персональных данных в соответствии с действующим законодательством Республики Казахстан как неавтоматизированным, так и автоматизированным способами.

                            Данное согласие действует в течение срока хранения информации в вышеуказанных целях. Данное согласие может быть отозвано в любой момент по моему письменному заявлению, отправленному в адрес Компании по ее юридическому адресу, зарегистрированному на дату отправки заявления или посредством направления электронного сообщения на электронную почту Компании Info.kz@pernod-ricard.com, путем отправления письменного запроса по адресу: ул.Рубинштейна, дом 48 , Медеуский район, г. Алматы Республика Казахстан, А26T8F4, или иным законным способом, доступным в Компании. В случае отзыва настоящего согласия все мои Персональные данные подлежат уничтожению из базы данных Компании.

                            Я подтверждаю, что для включения моих персональных данных в базу данных, в том числе партнеров указанных компаний, передачи, распространения, дополнения и прочей обработки моих персональных данных указанными компаниями с вышеупомянутой целью не требуется дополнительного уведомления меня о совершении данных действий.

                            Я подтверждаю, что, давая настоящее согласие, я действую по собственной воле, в своих интересах и полностью осознаю суть и цели настоящего документа.`,
                },
                rules: {
                    title: "Полные правила активности",
                    content: `ПРАВИЛА АКТИВАЦИИ «УЗНАЙ СВОЙ BALLANTINE'S»
                        Настоящие Правила определяют условия и порядок проведения активации «Узнай свой Ballantine's» (далее — «Активация»).
                        1. ОРГАНИЗАТОР
                        1.1. Организатором Активации является ТОО «Перно Рикар Казахстан» (БИН 050840001045), Республика Казахстан, г. Алматы, Медеуский район, ул. Рубинштейна, дом 48, почтовый индекс A26T8F4, далее - «Организатор».
                        1.2. Активация не является лотереей, азартной игрой или иной деятельностью, требующей специального разрешения.
                        2. СРОКИ ПРОВЕДЕНИЯ
                        2.1. Активация проводится с 16 мая 2026 года по 31 мая 2026 года включительно (далее - «Период проведения»).
                        2.2. Организатор вправе изменить сроки проведения Активации, опубликовав соответствующее уведомление на официальном ресурсе Активации.
                        3. УЧАСТНИКИ
                        3.1. Участником Активации может стать физическое лицо, достигшее 21 (двадцати одного) года, являющееся дееспособным гражданином Республики Казахстан.
                        3.2. Участие в Активации означает полное и безоговорочное согласие участника с настоящими Правилами.
                        3.3. К участию в Активации не допускаются сотрудники Организатора, а также члены их семей.
                        3.4. Принимая участие в Активации, Участник подтверждает, что его участие не нарушает законодательство Республики Казахстан и положения настоящих Правил.
                        4. МЕХАНИКА АКТИВАЦИИ
                        4.1. Для участия в Активации Участнику необходимо:
                        а. Ответить на вопросы тематического квиза на официальном ресурсе Активации в Период ее проведения;
                        б. Ознакомиться с персонализированным результатом, определяющим один из продуктов Ballantine's (Finest, 7 American Barrel или 12 Year Old);
                        в. Пройти регистрацию, предоставив достоверные контактные данные (имя, фамилия, пол, e-mail, номер телефона, город проживания).
                        4.2. После успешной регистрации Участник автоматически включается в число участников, имеющих возможность получить тот SKU, который соответствует его результату квиза.
                        4.3. Каждый Участник вправе зарегистрироваться и ответить на вопросы квиза только один раз. Проверка уникальности пользователя осуществляется по номеру телефона. Использование одного номера телефона для регистрации нескольких аккаунтов, в том числе с разными адресами электронной почты и иными регистрационными данными, запрещено.
                        5. ПУЛ ПРЕДОСТАВЛЯЕМЫХ ЕДИНИЦ
                        5.1. Фонд Активации состоит из 3 (трёх) предоставляемых единиц:
                        - 1 (одна) единица Ballantine's Finest - для определения Участника среди Участников с результатом «Ballantine's Finest»;
                        - 1 (одна) единица Ballantine's 7 American Barrel - для определения Участника среди Участников с результатом «Ballantine's 7 American Barrel»;
                        - 1 (одна) единица Ballantine's 12 Year Old - для определения Участника среди Участников с результатом «Ballantine's 12 Year Old».
                        5.2. Предоставляемые единицы не подлежат замене на денежный эквивалент или иные товары/услуги.
                        5.3. Предоставляемые единицы не могут быть переданы третьим лицам.
                        6. ОПРЕДЕЛЕНИЕ УЧАСТНИКОВ, ПОЛУЧАЮЩИХ ПРЕДОСТАВЛЯЕМУЮ ЕДИНИЦУ
                        6.1. По окончании Периода проведения Активации Организатор определяет 3 (трёх) Участников, которые получат возможность получить предоставляемую в Активации единицу (по одному в каждой категории) методом случайного выбора среди всех зарегистрированных Участников соответствующего пула.
                        6.2. Результаты направляются всем Участникам на указанный при регистрации адрес электронной почты в течение 5 (пяти) рабочих дней после завершения Активации.
                        6.3. Участник, которые определен к получению предоставляемой единицы, обязан подтвердить получение уведомления в течение 5 (пяти) рабочих дней с момента его отправки. В случае отсутствия ответа Организатор вправе провести выбрать иного Участника аналогичным методом.
                        7. ПОЛУЧЕНИЕ ПРЕДОСТАВЛЯЕМОЙ ЕДИНИЦЫ
                        7.1. Для получения предоставляемой единицы Участник, которые определен к получению предоставляемой единицы, обязан предъявить Организатору документ, удостоверяющий личность, а также подтверждение достижения им возраста 21 года.
                        7.2. Предоставляемая единица передаётся лично Участник, который определен к ее получению. Способ и место передачи согласовываются с Организатором индивидуально.
                        7.3. Предоставляемая единица передаётся исключительно Участнику, который определен к ее получению.
                        8. ПЕРСОНАЛЬНЫЕ ДАННЫЕ
                        8.1. Принимая участие в Активации, Участник даёт Организатору согласие на сбор, обработку, хранение и передачу (в том числе трансграничную передачу) своих персональных данных в целях участия в Активации, определения Участника, который определен к получению предоставляемой единицы и уведомления его о результатах; предоставления информации об Организаторе и его аффилированных лицах, о товарах и услугах Организатора, об активностях Организатора, о научных исследованиях или иных данных в отношении товаров или услуг Организатора; приглашения к участию в активностях, опросах и исследованиях, мероприятиях, программах, в том числе программах лояльности Организатора или его партнеров, включая исполнения обязательств Организатора и/или его партнеров по таким программам; улучшения качества товаров и услуг, улучшения опыта взаимодействия потребителя с Организатором, разработки коммуникаций и сервисных решений.
                        8.2 Действия, определенные в п.8.1., осуществляются в соответствии с законодательством Республики Казахстан о персональных данных и их защите.
                        8.3. После завершения Активации персональные данные Участников хранятся Организатором в информационных системах Организатора. Участник вправе направить Организатору запрос об удалении своих персональных данных, однако Организатор вправе отказать в удалении, если хранение данных необходимо в силу требований законодательства или законных интересов Организатора. Участник вправе получать информацию о своих персональных данных и их обработке; требовать уточнения, блокирования или уничтожения персональных данных; отзывать согласие на обработку персональных данных; обжаловать действия Организатора в уполномоченном государственном органе или в судебном порядке; актуализировать свои персональные данные, направив запрос на электронную почту: Info.kz@pernod-ricard.com с пометкой «Актуализация персональных данных».

                        9. ОТВЕТСТВЕННОСТЬ
                        9.1. Организатор не несёт ответственности за технические сбои, нарушения связи или иные обстоятельства, препятствующие участию в Активации, если они возникли не по вине Организатора.
                        9.2. Организатор не несёт ответственности за достоверность данных, указанных Участником при регистрации.
                        9.3. Организатор вправе отстранить Участника от Активации в случае нарушения настоящих Правил или законодательства Республики Казахстан.
                        10. ПРОЧИЕ УСЛОВИЯ
                        10.1. Организатор оставляет за собой право вносить изменения в настоящие Правила, публикуя актуальную версию на официальном ресурсе Активации.
                        10.2. Активация проводится на территории Республики Казахстан.
                        10.3. Все споры, возникающие в связи с проведением Активации, разрешаются в соответствии с законодательством Республики Казахстан.
                        10.4. Активация направлена исключительно на потребителей, достигших установленного законодательством возраста для употребления алкогольной продукции и соответствующих требованиям, установленным настоящими Правилами.

                        ЗЛОУПОТРЕБЛЕНИЕ АЛКОГОЛЕМ ВРЕДИТ ВАШЕМУ ЗДОРОВЬЮ.
                        Продукция предназначена только для лиц старше 21 года.`,
                }
            },
            config: {
                ...config,

                // bgLogoMainMobile: require(`@/assets/img/${config.bgLogoMainMobile}`),
                // bgLogoMain: require(`@/assets/img/${config.bgLogoMain}`),
                // logoMain: require(`@/assets/img/${config.logoMain}`),
                // logoMainMobile: require(`@/assets/img/${config.logoMainMobile}`),
                // logoInvisible: require(`@/assets/img/${config.logoInvisible}`),
                // bigImage: require(`@/assets/img/${config.bigImage}`),
                // bigImageMobile: require(`@/assets/img/${config.bigImageMobile}`),
                // footer: {
                //     ...config.footer,
                //     logoMainFooter: require(`@/assets/img/${config.footer.logoMainFooter}`),
                //     logoMainMobileFooter: require(`@/assets/img/${config.footer.logoMainMobileFooter}`),
                //     logo: require(`@/assets/img/${config.footer.logo}`),
                //     // Если есть другие картинки в футере — добавь их сюда
                // }
            }
        };
    },
    created() {
        if (localStorage.getItem("userAge") !== null) {
            this.showConfirm = false
        }
    },
    computed: {
        ...mapGetters(['getUserAge']),
        filteredQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type === 11 || q.type === 12));
        },
        normalQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type !== 11 && q.type !== 3 && q.type !== 12 && q.type !== 13 && q.type !== 14));
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        initLanding({
            brand: 'ballantines',
            activation: 'ballantines_zvuk_2026',
            landing_id: 'ballantines-zvuk-2026',
            landing_type: 'registration'
        });
        console.log('Возраст пользователя:', this.getUserAge);
        this.getFormFields();
        // Здесь можно использовать this.getUserAge.day, .month, .year
    },
    watch: {
        formData: {
            deep: true,
            handler(val) {
                for (let [id, value] of Object.entries(val)) {
                    this.validateField(id, value);
                }
            }
        },
        getUserAge(newVal) {
            if (!newVal || !this.formSchema) return;

            const birthQuestion = this.formSchema.questions.find(q => q.type === 3);
            if (birthQuestion) {
                this.$set(this.formData, birthQuestion.id, newVal);
                console.log("NEW DATA");
            }
        }
    },
    methods: {
        scrollToDetails() {
            const secondBlock = document.getElementById('second-section') || document.querySelector('.second-contaier');
            if (secondBlock) {
                secondBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        scrollToStepper() {
            this.scrollToDetails();
        },
        onConfirmed() {
            this.showConfirm = false
            console.log("Компонент закрыт")
            // localStorage.setItem("ageConfirmed", "1")
        },
        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },
        //     onFinish (rsp) {
        //     this.loading = true
        //     setTimeout(() => {
        //       this.loading = false
        //       this.snackbarColor = (rsp === this.expectedOtp) ? 'success' : 'warning'

        //     }, 3500)
        //   },
        validateField(question) {
            const value = this.formData[question.id];
            let error = null;

            // Проверка только для текстовых полей (например id 1,2,7,4)
            if ([1, 2, 4, 7].includes(question.type)) {
                if (!value || value.trim() === "") {
                    error = "Поле обязательно";
                }
            }
            if ([11].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if ([12].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if (error === null) {
                if ([1].includes(question.type)) {
                    // Имя только буквы
                    if (!/^[А-Яа-яA-Za-zӘәҒғҚқҢңӨөҰұҮүҺһІі\s-]+$/.test(value)) {
                        error = "Введите корректное имя.";
                    }
                }

                if ([2].includes(question.type)) {
                    // Фамилия только буквы
                    if (!/^[А-Яа-яA-Za-zӘәҒғҚқҢңӨөҰұҮүҺһІі\s-]+$/.test(value)) {
                        error = "Введите корректную фамилию.";
                    }
                }

                if ([7].includes(question.type)) {
                    // Email
                    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
                        error = "Введите корректный email.";
                    }
                }

                if ([4].includes(question.type)) {
                    // Телефон
                    if (!/^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(value)) {
                        error = "Введите корректный номер телефона.";
                    }
                }
            }

            this.$set(this.errors, question.id, error);
        },
        markTouched(question) {
            trackFormStart('main_registration');
            this.$set(this.touched, question.id, true);
            this.validateField(question);
        },
        getPlaceholder(question, isMobile = false) {
            switch (question.type) {
                case 5:
                    return "Город";
                case 9:
                    return isMobile ? "Какой Ballantine's вы предпочитаете" : "Продукт";
                case 10:
                    return isMobile ? "Ваш логин в Instagram" : "Введите логин";
                default:
                    return question.name;
            }
        },
        getFormFields() {
            this.isLoadingForm = true;
            this.formError = false;
            this.$http.get('/api/survey', {
                params: {
                    campaignId: "98b65cea-88bd-f111-b802-00155d79212a"
                }
            })
                .then(res => {
                    this.formSchema = res.data;
                    res.data.questions.forEach(q => {
                        if (q.type === 3) {
                            this.$set(this.formData, q.id, this.getUserAge);
                        } else {
                            this.$set(this.formData, q.id, "");
                        }
                    });
                })
                .catch(err => {
                    this.formError = true;
                    console.error("Ошибка загрузки формы", err);
                })
                .finally(() => {
                    this.isLoadingForm = false;
                });
        },
        submitForm() {
            console.log("Отправка формы:", this.formData);
            // пример отправки
            // this.$http.post("/api/survey/submit", this.formData)
        },
        openPopup(type) {
            this.currentPopup = type
            this.isPopupOpen = true
        },
        goTo(url) {
            window.open(url, '_blank'); // Откроется в новой вкладке
        },
        logCity() {
            console.log(this.city);
        },
        logNumber() {
            console.log(this.phone);
        },
        async sendVerificationCode() {
            const phoneQuestion = this.formSchema.questions.find(q => q.type === 4);
            if (!phoneQuestion) return false;

            const phoneAnswerRaw = this.formData[phoneQuestion.id];
            const phoneAnswer = phoneAnswerRaw.replace(/[^\d+]/g, "");
            try {
                this.isSendSms = true; // Блокируем кнопку, пока идет проверка капчи
                await this.$recaptchaLoaded();
                const recaptchaToken = await this.$recaptcha('send_sms');
                // Готовим DTO
                const answerDto = {
                    campaignId: "98b65cea-88bd-f111-b802-00155d79212a",
                    surveyAnswer: {
                        surveyQuestionId: phoneQuestion.id,
                        answer: phoneAnswer
                    },
                    recaptchaToken: recaptchaToken
                };
                console.log("Token:", recaptchaToken);
                console.log(answerDto);
                await this.$http.post("/api/Verification/SendCode", answerDto);
                console.log("Код отправлен!");
                this.otpErrorSms = false;
                return true;
            } catch (err) {
                console.error("Ошибка при отправке кода:", err);
                if (err?.response?.status === 409) {
                    // пользователь уже зарегистрирован
                    trackFormError({
                        formId: 'main_registration',
                        errorType: 'server',
                        fieldName: 'phone',
                        errorTextCode: 'phone_already_registered'
                    });
                    this.otpErrorSms = true;
                    this.showOtpPopup = true;
                    this.otpSuccess = false;
                    return false;
                }
                if (err?.response?.status === 403) {
                    // Бэкенд отбил запрос из-за низкого score капчи
                    trackFormError({
                        formId: 'main_registration',
                        errorType: 'captcha',
                        fieldName: 'recaptcha',
                        errorTextCode: 'captcha_rejected'
                    });
                    this.snackbar = true;
                    this.message = 'Подозрение на бота. Попробуйте перезагрузить страницу.';
                    return false;
                }
                this.snackbar = true;
                this.message = 'Ошибка при отправке кода. Попробуйте снова.';
                return false;
            } finally {
                this.isSendSms = false;
            }
        },
        async resendSms() {
            // можно просто вызвать sendVerificationCode ещё раз
            await this.startSmsTimer();
            await this.sendVerificationCode();
        },
        async confirmRegistration() {
            trackFormSubmit('main_registration');
            this.otpError = "";
            if (!this.formSchema) return;

            let hasErrors = false;
            if (Array.isArray(this.formSchema.questions)) {
                this.formSchema.questions.forEach(q => {
                    this.validateField(q);
                    const val = this.formData[q.id];
                    const err = this.errors[q.id];

                    let fieldName = 'field_' + q.id;
                    switch (q.type) {
                        case 1: fieldName = 'name'; break;
                        case 2: fieldName = 'surname'; break;
                        case 3: fieldName = 'birth_date'; break;
                        case 4: fieldName = 'phone'; break;
                        case 5: fieldName = 'city'; break;
                        case 7: fieldName = 'email'; break;
                        case 9: fieldName = 'product_choice'; break;
                        case 10: fieldName = 'instagram'; break;
                        case 11: fieldName = 'consent_personal_data'; break;
                        case 12: fieldName = 'consent_rules'; break;
                    }

                    const isEmpty = val === null || val === undefined || val === '' || ((q.type === 11 || q.type === 12) && val === false);

                    if (err || isEmpty) {
                        hasErrors = true;
                        let code = 'validation_error';
                        if (isEmpty) {
                            code = (q.type === 11 || q.type === 12) ? 'consent_required' : `${fieldName}_empty`;
                        } else if (q.type === 4) {
                            code = 'phone_invalid_format';
                        } else if (q.type === 7) {
                            code = 'email_invalid_format';
                        } else if (q.type === 1 || q.type === 2) {
                            code = `${fieldName}_invalid_format`;
                        }
                        trackFormError({
                            formId: 'main_registration',
                            errorType: 'validation',
                            fieldName,
                            errorTextCode: code
                        });
                    }
                });
            }

            if (hasErrors) {
                this.snackbar = true;
                this.message = 'Пожалуйста, заполните все обязательные поля корректно';
                return;
            }
            try {
                this.isSendSms = true;
                const isSent = await this.sendVerificationCode();
                if (isSent && !this.otpErrorSms) {
                    this.otpError = "";
                    this.otpSuccess = false;
                    this.showOtpPopup = true;
                    this.startSmsTimer();
                }
            } catch {
                this.snackbar = true;
                this.message = 'Ошибка при отправке кода. Попробуйте снова.';
            } finally {
                this.isSendSms = false;
            }
        },
        async submitAnswersWithCode(code) {
            this.otpVerifying = true;
            this.otpError = "";
            this.otpSuccess = false;
            try {
                const payload = {
                    surveyId: this.formSchema.id,
                    campaignId: "98b65cea-88bd-f111-b802-00155d79212a",
                    verificationCode: code,
                    answers: Object.entries(this.formData).map(([key, value]) => {
                        let answer = String(value);

                        if (/^\+7[\d\s()-]{10,}$/.test(answer)) {
                            answer = answer.replace(/[^\d+]/g, '');
                        }

                        return {
                            surveyQuestionId: key,
                            answer
                        };
                    })
                };

                await this.$http.post('/api/AnswerSet', payload);
                this.otpSuccess = true;

                // Track successful registration and virtual page view
                const cityQuestion = this.formSchema?.questions?.find(q => q.type === 5);
                const productQuestion = this.formSchema?.questions?.find(q => q.type === 9);

                let cityName = '';
                if (cityQuestion && this.formData[cityQuestion.id]) {
                    const ans = (cityQuestion.answers || []).find(a => a.id === this.formData[cityQuestion.id]);
                    cityName = ans ? ans.name : String(this.formData[cityQuestion.id]);
                }

                let productName = '';
                if (productQuestion && this.formData[productQuestion.id]) {
                    const ans = (productQuestion.answers || []).find(a => a.id === this.formData[productQuestion.id]);
                    productName = ans ? ans.name : String(this.formData[productQuestion.id]);
                }

                trackRegistrationSuccess({
                    formId: 'main_registration',
                    city: cityName,
                    productChoice: productName
                });

                trackVirtualPageView('/zvuk/thank-you', 'Спасибо за регистрацию');

                this.resetForm();
            } catch (error) {
                console.error(error);
                const msg = error?.response?.data?.message || "Код введён неверно";
                this.otpError = msg;
                trackFormError({
                    formId: 'main_registration',
                    errorType: 'server',
                    fieldName: 'otp_code',
                    errorTextCode: 'otp_invalid_code'
                });
            } finally {
                this.otpVerifying = false;
            }
        },
        resetForm() {
            // Правильно очищаем форму, СОХРАНЯЯ все ID вопросов
            if (this.formSchema && this.formSchema.questions) {
                this.formSchema.questions.forEach(q => {
                    if (q.type === 3) {
                        this.$set(this.formData, q.id, this.getUserAge);
                    } else {
                        this.$set(this.formData, q.id, ""); // Возвращаем пустые строки
                    }
                });
            }

            // Сбрасываем ошибки валидации
            this.errors = {};
            this.touched = {};

            // Скроллим пользователя наверх страницы
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        resetFormAndQuiz() {
            this.resetForm();
        },
        async startSmsTimer() {
            this.smsTimer = 60;
            if (this.smsTimerInterval) clearInterval(this.smsTimerInterval);
            this.smsTimerInterval = setInterval(() => {
                if (this.smsTimer > 0) {
                    this.smsTimer--;
                } else {
                    clearInterval(this.smsTimerInterval);
                    this.smsTimerInterval = null;
                    // Здесь можно вызвать метод компонента otp через $refs, если нужно
                }
            }, 1000);
        },
        onPhoneFocus(question) {
            trackFormStart('main_registration');
            if (!this.formData[question.id]) {
                this.$set(this.formData, question.id, '+7');
            }
        },
        onPhoneInput(question) {
            const val = this.formData[question.id] || '';
            if (!val.startsWith('+7')) {
                this.formData[question.id] = '+7' + val.replace(/\D/g, '').slice(1);
            }
            this.validateField(question);
        },
        closePopup() {
            this.showPopup = false;
            this.isPopupOpen = false; // Закрыть pop-up
            // Очистка полей
            this.phone = '';
            this.email = '';
            this.name = '';
            this.city = '';
            this.surname = '';
            this.checkbox = false;
        },
    }
}


</script>